import React, {useState} from 'react'
import Modal from '../../../components/Modal'
import NewModal from '../../../components/NewModal/NewModal'
import Form from '../../../components/Form/Form'
import {useForm} from 'react-hook-form'
import FormInput from '../../../components/Inputs/FormInput/FormInput'
import {useHistory, useParams} from 'react-router-dom'
import {useHttp} from '../../../hooks/http.hook'
import {General_API} from '../General_API'
import AttentionGenerator from '../../../components/Form/AttentionGenerator'
import styled from 'styled-components'

function PasswordRestore(props) {
    const {request} = useHttp()
    const {register, errors, handleSubmit} = useForm()
    const [requestResponse, setRequestResponse] = useState({})
    const {restoreType} = useParams() // patient || organization
    const history = useHistory()
    const {passwordRestoreStep1} = General_API.passwordRestore

    const restoreWithEmail = async (form) => {
        const preparedForm = {...form, type: restoreType}
        await setRequestResponse(await request(process.env.REACT_APP_BASE_URL + passwordRestoreStep1().api, passwordRestoreStep1().method, preparedForm, {}))
    }
    return (
        <Modal styles={{top: '0'}}>
            <NewModal completedButtonText={'Вернуться'}
                      hideCloseButton
                      hideErrors
                      completed={requestResponse.status === 200 && requestResponse?.data?.message === 'ok'}
                      title={'Восстановление пароля'}
                      closeHandler={() => history.push(process.env.REACT_APP_URL_PREFIX)}
                      completedText={requestResponse?.data && <>
                          На вашу электронную почту <Email>{requestResponse?.data.data[0]?.email}</Email>,
                          был отправлен запрос на сброс пароля. Пожалуйста, следуйте инструкциям в письме.
                      </>
                      }
            >
                <AttentionGenerator errors={{
                    ...errors,
                    error: {message: requestResponse.status === 200 && requestResponse?.data?.message !== 'ok' ? requestResponse?.data?.message : ''}
                }}/>
                <Form submitButtonText={'Продолжить'} submitHandler={handleSubmit(restoreWithEmail)}>


                    <FormInput name={'email'} reff={register({required: 'Введите вашу электронную почту'})} hideIcon
                               title={'E-Mail'} type='email'/>
                </Form>

            </NewModal>
        </Modal>
    )
}

const Email = styled.span`
  color: #7fc4fd;
`


export default PasswordRestore
